import axios from 'axios'
import { CAR_API_URL } from 'lib/env'
import { createError } from 'requests/errors'

export const getCarList = async (filter) => {
  try {
    const res = await axios.post(CAR_API_URL + '/cars/list', filter)
    return res.data
  } catch (e) {
    return createError(e)
  }
}